import Backend from 'App/Dataman-Backend';
import { apiGet } from '@/app/api/core/http';
import { isFile } from '@/app/api/core/images';
import { CAT_INFORMATION_SOURCES, CAT_INFORMATION_SOURCE_SNAPSHOTS } from 'App/utils/Collections';
import { INFORMATION_SOURCES_PATHS } from './paths';

export const informationSourcesApiAdapter = {
  [CAT_INFORMATION_SOURCES]: {
    getList: (params) =>
      apiGet(INFORMATION_SOURCES_PATHS.informationSources + INFORMATION_SOURCES_PATHS.suffix, { params }),
    getItem: (id, params) => apiGet(`${INFORMATION_SOURCES_PATHS.informationSources}/${id}`, { params }),
  },
  [CAT_INFORMATION_SOURCE_SNAPSHOTS]: {
    getList: (params) =>
      apiGet(INFORMATION_SOURCES_PATHS.informationSourceSnapshots + INFORMATION_SOURCES_PATHS.suffix, { params }),
  },
};

// External services backing the product "Sources" tab
export const infoSourcesService = {
  checkUrl: async (url, id) => {
    try {
      const config = {
        url: INFORMATION_SOURCES_PATHS.extractImages,
        headers: { accept: 'application/json' },
        data: new FormData(),
        auth: true,
      };
      config.data.append('id', id);
      config.data.append('url', url);
      const response = await Backend.post(config);
      return response;
    } catch (err) {
      const { response } = err || {};
      if (response) {
        return response;
      } else {
        const { message } = err.toJSON();
        throw new Error(message);
      }
    }
  },
  news: {
    query: async (params) => {
      try {
        return Backend.request(INFORMATION_SOURCES_PATHS.newsQuery, 'get', {
          params,
          headers: { accept: 'application/json' },
          auth: false,
        });
      } catch (err) {
        const { status } = err?.response || {};
        if (status >= 400) {
          return err?.response;
        } else {
          const { message } = err.toJSON();
          throw new Error(message);
        }
      }
    },
  },
  recognizeImage: async (image) => {
    const config = {
      url: INFORMATION_SOURCES_PATHS.textRecognition,
      headers: { 'content-type': 'multipart/form-data' },
      data: new FormData(),
      auth: true,
    };
    config.data.append(isFile(image) ? 'file' : 'url', image);
    return Backend.post(config);
  },
};
